/**
 * AcordeonItem — ítem de acordeón nativo (`<details>/<summary>`) para las
 * páginas de Ayuda (vecino, comisión, tesorería).
 *
 * Nativo = accesible y sin estado de React; ideal para móvil (≈80% del
 * acceso del barrio es por celular). Toca el título para abrir/cerrar.
 *
 * Extraído del `Item` local de `pages/Ayuda.tsx` (F14) para reusarlo en
 * la Ayuda por vista sin duplicar.
 */
import type { ReactNode } from 'react';

interface AcordeonItemProps {
  titulo: string;
  children: ReactNode;
}

export function AcordeonItem({ titulo, children }: AcordeonItemProps) {
  return (
    <details className="group border-b border-white/[0.08] py-3">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-medium text-text-primary">
        <span>{titulo}</span>
        <span className="text-text-muted transition-transform group-open:rotate-180">
          ▾
        </span>
      </summary>
      <div className="mt-2 space-y-2 text-sm text-text-secondary">
        {children}
      </div>
    </details>
  );
}
